import React from "react";
import { accessor } from "./DefaultCellRenderer";
import PropTypes from "prop-types";
import moment from "moment";

export function make(format = "llll") {
  function DateCellRenderer({ row, head }) {
    const { label } = head;
    const value = accessor(row, head.field);

    return (
      <td
        className={`DynamicTableData__Cell__${(label || "").replace(" ", "_")}`}
        title={value ? moment(value).fromNow() : "-"}
      >
        {value ? moment(value).format(format) : '-'}
      </td>
    );
  }

  DateCellRenderer.propTypes = {
    row: PropTypes.shape().isRequired,
    head: PropTypes.shape().isRequired,
  };

  return DateCellRenderer;
}

const Interface = { make };

export default Interface;
